module.exports = __webpack_public_path__ + "files/17ee62d79c8c9e3dc55689204f3515f1.png";